import { useState } from "react";
import gemini from "../pages/YourAIAgents/components/assets/gemini.svg";

export default function ImageWithFallback({ src, alt }) {
  const [error, setError] = useState(false);

  return error ? (
    <img src={gemini} alt="gemini" className="w-[20px]" />
  ) : (
    <img
      src={src}
      alt={alt}
      className="w-[16px]"
      onError={() => setError(true)}
    />
  );
}
